import { getStore } from '../store/store';

export const getRibbonViewMode = () => getStore().viewMode;
